import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  CHECKLIST_TEMPLATE_LIST_ACTIVE,
  CHECKLIST_TEMPLATE_ASSIGN_TO_TASK,
  CHECKLIST_SEARCH,
  CHECKLIST_DATA,
  CHECKLIST_UPDATE,
  CHECKLIST_PDF_SHEET,
  DELETE_TASK_CHECKLIST,
  CHECKLIST_MERGE_WITH_TEMPLATE,
  TASK_CHECKLIST_SEARCH,
  TASK_CHECKLIST_LIST,
  CHECKLIST_PDF_SHEET_DEBUG,
  CREATE_CHECKLIST_TEMPLATE,
  UPDATE_CHECKLIST_TEMPLATE,
  CLONE_CHECKLIST_TEMPLATE,
  CHECKLIST_TEMPLATE_DATATYPE_LIST,
  CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST,
  CHECKLIST_TEMPLATE_PDFTHEME_LIST,
} from "./actionType";

import {
  checkListTemplateListActiveSuccess,
  checkListTemplateListActiveFailure,
  checkListTemplateAssignToTaskSuccess,
  checkListTemplateAssignToTaskFailure,
  checkListSearchSuccess,
  checkListSearchFailure,
  checkListDataSuccess,
  checkListDataFailure,
  checkListUpdateSuccess,
  checkListUpdateFailure,
  checkListPdfSheetSuccess,
  checkListPdfSheetFailure,
  deleteTaskCheckListSuccess,
  deleteTaskCheckListFailure,
  checkListMergeWithTemplateSuccess,
  checkListMergeWithTemplateFailure,
  taskCheckListSearchSuccess,
  taskCheckListSearchFailure,
  taskCheckListListSuccess,
  taskCheckListListFailure,
  checkListPdfSheetDebugSuccess,
  checkListPdfSheetDebugFailure,
  createCheckListTemplateSuccess,
  createCheckListTemplateFailure,
  updateCheckListTemplateSuccess,
  updateCheckListTemplateFailure,
  cloneCheckListTemplateSuccess,
  cloneCheckListTemplateFailure,
  checkListTemplateDataTypeListSuccess,
  checkListTemplateDataTypeListFailure,
  checkListTemplateSystemFieldListSuccess,
  checkListTemplateSystemFieldListFailure,
  checkListTemplatePdfThemeListSuccess,
  checkListTemplatePdfThemeListFailure,
} from "./action";

import {
  checkListTemplateListActiveApi,
  checkListTemplateAssignToTaskApi,
  checkListSearchApi,
  checkListDataApi,
  checkListUpdateApi,
  checkListPdfSheetApi,
  deleteTaskCheckListApi,
  checkListMergeWithTemplateApi,
  taskCheckListSearchApi,
  taskCheckListListApi,
  checkListPdfSheetDebugApi,
  createCheckListTemplateApi,
  updateCheckListTemplateApi,
  cloneCheckListTemplateApi,
  checkListTemplateDataTypeListApi,
  checkListTemplateSystemFieldListApi,
  checkListTemplatePdfThemeListApi,
} from "../../helpers/fakebackend_helper";

// CheckList Template List Active
function* checkListTemplateListActive() {
  try {
    const response = yield call(checkListTemplateListActiveApi);
    yield put(checkListTemplateListActiveSuccess(response));
  } catch (error) {
    yield put(checkListTemplateListActiveFailure(error));
  }
}

function* watchCheckListTemplateListActive() {
  yield takeEvery(CHECKLIST_TEMPLATE_LIST_ACTIVE, checkListTemplateListActive);
}

// CheckList Template Assign To Task
function* checkListTemplateAssignToTask({ payload }) {
  try {
    const response = yield call(checkListTemplateAssignToTaskApi, payload);
    yield put(checkListTemplateAssignToTaskSuccess(response));
  } catch (error) {
    yield put(checkListTemplateAssignToTaskFailure(error));
  }
}

function* watchCheckListTemplateAssignToTask() {
  yield takeEvery(
    CHECKLIST_TEMPLATE_ASSIGN_TO_TASK,
    checkListTemplateAssignToTask
  );
}

// CheckList Search
function* checkListSearch({ payload }) {
  try {
    const response = yield call(checkListSearchApi, payload);
    yield put(checkListSearchSuccess(response));
  } catch (error) {
    yield put(checkListSearchFailure(error));
  }
}

function* watchCheckListSearch() {
  yield takeEvery(CHECKLIST_SEARCH, checkListSearch);
}

// CheckList Data
function* checkListData({ payload }) {
  try {
    const response = yield call(checkListDataApi, payload);
    yield put(checkListDataSuccess(response));
  } catch (error) {
    yield put(checkListDataFailure(error));
  }
}

function* watchCheckListData() {
  yield takeEvery(CHECKLIST_DATA, checkListData);
}

// CheckList Update
function* checkListUpdate({ payload }) {
  try {
    const response = yield call(checkListUpdateApi, payload);
    yield put(checkListUpdateSuccess(response));
  } catch (error) {
    yield put(checkListUpdateFailure(error));
  }
}

function* watchCheckListUpdate() {
  yield takeEvery(CHECKLIST_UPDATE, checkListUpdate);
}

// CheckList PDF Sheet
function* checkListPdfSheet({ payload }) {
  try {
    const response = yield call(checkListPdfSheetApi, payload);
    yield put(checkListPdfSheetSuccess(response));
  } catch (error) {
    yield put(checkListPdfSheetFailure(error));
  }
}

function* watchCheckListPdfSheet() {
  yield takeEvery(CHECKLIST_PDF_SHEET, checkListPdfSheet);
}

// Delete Task CheckList
function* deleteTaskCheckList({ payload }) {
  try {
    const response = yield call(deleteTaskCheckListApi, payload);
    yield put(deleteTaskCheckListSuccess(response));
  } catch (error) {
    yield put(deleteTaskCheckListFailure(error));
  }
}

function* watchDeleteTaskCheckList() {
  yield takeEvery(DELETE_TASK_CHECKLIST, deleteTaskCheckList);
}

// CheckList Merge With Template
function* checkListMergeWithTemplate({ payload }) {
  try {
    const response = yield call(checkListMergeWithTemplateApi, payload);
    yield put(checkListMergeWithTemplateSuccess(response));
  } catch (error) {
    yield put(checkListMergeWithTemplateFailure(error));
  }
}

function* watchCheckListMergeWithTemplate() {
  yield takeEvery(CHECKLIST_MERGE_WITH_TEMPLATE, checkListMergeWithTemplate);
}

// Task CheckList Search
function* taskCheckListSearch({ payload }) {
  try {
    const response = yield call(taskCheckListSearchApi, payload);
    // Backend (PHP) may encode the list as an object keyed "0","1",...
    // when array keys are non-sequential; consumers expect an array.
    if (
      response?.taskchecklist_list &&
      !Array.isArray(response.taskchecklist_list)
    ) {
      response.taskchecklist_list = Object.values(response.taskchecklist_list);
    }
    yield put(taskCheckListSearchSuccess(response));
  } catch (error) {
    yield put(taskCheckListSearchFailure(error));
  }
}

function* watchTaskCheckListSearch() {
  yield takeEvery(TASK_CHECKLIST_SEARCH, taskCheckListSearch);
}

// Task CheckList List
function* taskCheckListList() {
  try {
    const response = yield call(taskCheckListListApi);
    yield put(taskCheckListListSuccess(response));
  } catch (error) {
    yield put(taskCheckListListFailure(error));
  }
}

function* watchTaskCheckListList() {
  yield takeEvery(TASK_CHECKLIST_LIST, taskCheckListList);
}

// CheckList PDF Sheet Debug
function* checkListPdfSheetDebug({ payload }) {
  try {
    const response = yield call(checkListPdfSheetDebugApi, payload);
    yield put(checkListPdfSheetDebugSuccess(response));
  } catch (error) {
    yield put(checkListPdfSheetDebugFailure(error));
  }
}
function* watchCheckListPdfSheetDebug() {
  yield takeEvery(CHECKLIST_PDF_SHEET_DEBUG, checkListPdfSheetDebug);
}

// Create CheckList Template
function* createCheckListTemplate({ payload }) {
  try {
    const response = yield call(createCheckListTemplateApi, payload);
    yield put(createCheckListTemplateSuccess(response));
  } catch (error) {
    yield put(createCheckListTemplateFailure(error));
  }
}
function* watchCreateCheckListTemplate() {
  yield takeEvery(CREATE_CHECKLIST_TEMPLATE, createCheckListTemplate);
}

// Update CheckList Template
function* updateCheckListTemplate({ payload }) {
  try {
    const response = yield call(updateCheckListTemplateApi, payload);
    yield put(updateCheckListTemplateSuccess(response));
  } catch (error) {
    yield put(updateCheckListTemplateFailure(error));
  }
}
function* watchUpdateCheckListTemplate() {
  yield takeEvery(UPDATE_CHECKLIST_TEMPLATE, updateCheckListTemplate);
}

// Clone CheckList Template
function* cloneCheckListTemplate({ payload }) {
  try {
    const response = yield call(cloneCheckListTemplateApi, payload);
    yield put(cloneCheckListTemplateSuccess(response));
  } catch (error) {
    yield put(cloneCheckListTemplateFailure(error));
  }
}
function* watchCloneCheckListTemplate() {
  yield takeEvery(CLONE_CHECKLIST_TEMPLATE, cloneCheckListTemplate);
}

// CheckList Template DataType List
function* checkListTemplateDataTypeList() {
  try {
    const response = yield call(checkListTemplateDataTypeListApi);
    yield put(checkListTemplateDataTypeListSuccess(response));
  } catch (error) {
    yield put(checkListTemplateDataTypeListFailure(error));
  }
}
function* watchCheckListTemplateDataTypeList() {
  yield takeEvery(
    CHECKLIST_TEMPLATE_DATATYPE_LIST,
    checkListTemplateDataTypeList
  );
}

// CheckList Template System Field List
function* checkListTemplateSystemFieldList() {
  try {
    const response = yield call(checkListTemplateSystemFieldListApi);
    yield put(checkListTemplateSystemFieldListSuccess(response));
  } catch (error) {
    yield put(checkListTemplateSystemFieldListFailure(error));
  }
}
function* watchCheckListTemplateSystemFieldList() {
  yield takeEvery(
    CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST,
    checkListTemplateSystemFieldList
  );
}

// CheckList Template PDF Theme List
function* checkListTemplatePdfThemeList() {
  try {
    const response = yield call(checkListTemplatePdfThemeListApi);
    yield put(checkListTemplatePdfThemeListSuccess(response));
  } catch (error) {
    yield put(checkListTemplatePdfThemeListFailure(error));
  }
}
function* watchCheckListTemplatePdfThemeList() {
  yield takeEvery(
    CHECKLIST_TEMPLATE_PDFTHEME_LIST,
    checkListTemplatePdfThemeList
  );
}

export default function* Checklist() {
  yield all([
    fork(watchCheckListTemplateListActive),
    fork(watchCheckListTemplateAssignToTask),
    fork(watchCheckListSearch),
    fork(watchCheckListData),
    fork(watchCheckListUpdate),
    fork(watchCheckListPdfSheet),
    fork(watchDeleteTaskCheckList),
    fork(watchCheckListMergeWithTemplate),
    fork(watchTaskCheckListSearch),
    fork(watchTaskCheckListList),
    fork(watchCheckListPdfSheetDebug),
    fork(watchCreateCheckListTemplate),
    fork(watchUpdateCheckListTemplate),
    fork(watchCloneCheckListTemplate),
    fork(watchCheckListTemplateDataTypeList),
    fork(watchCheckListTemplateSystemFieldList),
    fork(watchCheckListTemplatePdfThemeList),
  ]);
}
